module.exports = __webpack_public_path__ + "static/media/TOKEN_HUNTER.af3361aa.png";